export const LOG_REDACTED = '[redacted]';

export type LogRedacted = typeof LOG_REDACTED;

// A data-derived string whose format proves it safe. Redacts instead of throwing, so a malformed value
// never turns a report into an incident. Every subclass needs an entry in application/config/log_safe_values.json.
export abstract class LogSafeValue {
    private readonly value: string;

    protected constructor(value: unknown, pattern: RegExp) {
        this.value = typeof value === 'string' && pattern.test(value) ? value : LOG_REDACTED;
    }

    toString(): string {
        return this.value;
    }

    toJSON(): string {
        return this.value;
    }
}
